module.exports = __webpack_public_path__ + "d3ac7d481ffe83ef107705e9b3cdfee1.fbx";